import React, { useState } from "react";
import { Box, Paper, Tab, Tabs } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import UserPage from "./UserPage";
import VendorPage from "./VendorPage";
import TruckPage from "./TruckPage";
import BranchPage from "./BranchPage";
import RatePage from "./RatePage";
import RoutePage from "./RoutePage";

const useStyles = makeStyles((theme) => ({
  tabs: {
    flexGrow: 1,
  },
  flexColContainer: {
    display: "flex",
    flexDirection: "column",
  },
  flexColItem: {
    margin: theme.spacing(0, 0, 4, 0),
  },
}));

const MasterDataPage = () => {
  const [tab, setTab] = useState(0);
  const classes = useStyles();

  const entityPageList = [
    <UserPage />,
    <VendorPage />,
    <TruckPage />,
    <BranchPage />,
    <RatePage />,
    <RoutePage />,
  ];

  const handleChange = (event, newValue) => setTab(newValue);

  return (
    <Box className={classes.flexColContainer}>
      <Paper className={classes.flexColItem}>
        <Tabs value={tab} onChange={handleChange} variant="fullWidth">
          <Tab label="Users" />
          <Tab label="Vendors" />
          <Tab label="Trucks" />
          <Tab label="Branches" />
          <Tab label="Rates" />
          <Tab label="Routes" />
        </Tabs>
      </Paper>

      {entityPageList[tab]}
    </Box>
  );
};

export default MasterDataPage;
